// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__1I9RS","Div":"CustomFadeBox_Div__34e7n","LargeDiv":"CustomFadeBox_LargeDiv__dhdPM"};